import React from "react";
import { Link } from "react-router-dom";
import { FormattedHTMLMessage } from "react-intl";
import routing from "../../../routing";

import { availableLanguagesForTranslation, languages, getLangFlag } from "../../../../common/parameters";
import { LoaderWrapper, Loader } from "../../../components/Loader";
import User from "../../../components/User";

import { LanguageActions, Language, Members, Flag, Info, UserWrapper, UsersWrapper } from "./styles";
import { IProps } from "./interfaces";

class LanguageSelector extends React.Component<IProps> {
    state = {
        roles: [],
        translators: [],
        users: [],
        levels: [],
        isFetching: true,
        isInitalFetching: true,
    };
    componentDidMount() {
        this.getMyRoles();
    }
    applyLanguage = language => {
        this.setState({ isFetching: true });
        this.props.post("translation/apply-for-translation", { language }, () => {
            this.getMyRoles();
        });
    };
    stepBack = language => {
        this.setState({ isFetching: true });
        this.props.post("translation/step-back-from-translation", { language }, () => {
            this.getMyRoles();
        });
    };
    getMyRoles = () => {
        this.props.get("translation/my-roles", ({ data: { roles, translators, users, levels } }) => {
            this.setState({
                roles,
                translators,
                users,
                levels,
                isFetching: false,
                isInitalFetching: false,
            });
        });
    };
    render() {
        const {
            intl: { formatMessage },
        } = this.props;
        const { roles, translators, users, isFetching, levels, isInitalFetching } = this.state;
        return (
            <div>
                <h1>Translation</h1>
                <div>
                    <FormattedHTMLMessage id="translate.intro.top" />
                </div>
                {isInitalFetching && (
                    <LoaderWrapper>
                        <Loader />
                    </LoaderWrapper>
                )}
                {!isInitalFetching &&
                    availableLanguagesForTranslation.map(lang => {
                        const application = roles.find(role => role.language === lang);
                        const languageTranslators = translators.filter(({ language }) => language === lang);
                        const startAvailable = !!levels.find(
                            level => level.language === lang && level.status > 0 && level.status < 4
                        );
                        return (
                            <Language key={lang}>
                                <LanguageActions key={lang}>
                                    <h3>
                                        <Flag src={`/flags/${getLangFlag(lang)}.png`} />
                                        {languages(formatMessage).find(({ value }) => value === lang)?.label}
                                    </h3>
                                    {!application ? (
                                        <button
                                            disabled={isFetching}
                                            className="button"
                                            onClick={() => this.applyLanguage(lang)}
                                        >
                                            Apply
                                        </button>
                                    ) : application.active ? (
                                        <>
                                            {startAvailable ? (
                                                <Link to={`/${routing.translate}/${lang}`} className="button">
                                                    {"Start"}
                                                </Link>
                                            ) : (
                                                <button className="button" disabled>
                                                    {"Not open yet"}
                                                </button>
                                            )}
                                        </>
                                    ) : (
                                        <>
                                            <button
                                                disabled={isFetching}
                                                className="button button--light"
                                                onClick={() => this.stepBack(lang)}
                                            >
                                                Revoke
                                            </button>
                                            <Info>Thank you! We will contact you soon.</Info>
                                        </>
                                    )}
                                </LanguageActions>
                                {languageTranslators.length > 0 && (
                                    <Members>
                                        <hr />
                                        <UsersWrapper>
                                            {languageTranslators.map(({ user: userId }) => {
                                                const user = users.find(({ _id }) => _id === userId);
                                                if (!user) return null;
                                                return (
                                                    <UserWrapper key={userId}>
                                                        <User reversed user={user} />
                                                    </UserWrapper>
                                                    // <div key={user.username}>{user.displayName}</div>
                                                );
                                            })}
                                        </UsersWrapper>
                                    </Members>
                                )}
                            </Language>
                        );
                    })}
                <div>
                    <FormattedHTMLMessage id="translate.intro.bottom" />
                </div>
            </div>
        );
    }
}

export default LanguageSelector;
